import { render, staticRenderFns } from "./Disciplinas.vue?vue&type=template&id=5261967b&"
import script from "./Disciplinas.vue?vue&type=script&lang=js&"
export * from "./Disciplinas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports